<template>
  <div v-if="products.length > 1" class="products">
    <div class="products-list">
      <div class="line-products">
        <carousel
          v-if="products.length"
          :perPage="products.length < 3 ? products.length : 3"
          :navigationEnabled="true"
          ref="carousel"
        >
          <slide v-for="(item, index) in products" :key="index">
            <div class="product-card flip flex-col" :class="{
              'um-produto' : products.length == 1,
              'tres-produtos-ou-mais' : products.length >= 3,
              }" @click="perguntar()">
              <div class="top-card">
                <div class="bubble-bag">
                  <i class="fas fa-shopping-bag"></i>
                </div>
              </div>
              <div class="product-image-container">
                <div class="product-image-background">
                  <div class="product-image-to-front">
                    <img
                      :src="item.imagemUrl"
                      :alt="item.titulo"
                      class="product-image"
                    />
                  </div>
                </div>
              </div>
              <div class="product-section w-100 flex-col">
                <div class="w-100 mb-2 text-align-center">
                  <h3 class="product-title">{{ item.titulo }}</h3>
                </div>
                <div class="w-100 text-align-center div-product-price">
                  <span class="product-price">{{
                    Number(item.preco) | currency
                  }}</span>
                </div>
                <div class="btn-adicionar quantity">
                  <button
                    class="botao-quantidade plus card-qtd"
                    @click="selectProduct(item, 'cart-items')"
                  >
                    + Adicionar
                  </button>
                </div>
              </div>
              <div
                class="discount-section w-100 flex-col"
                v-if="Number(item.desconto)"
              >
                <!-- info de descontos -->
                <div class="w-100 discount-ticket">
                  <hr class="dashed-line" />
                  <div class="discount-desc">
                    <span class="price-discount">{{
                      Number(item.desconto) | currency
                    }}</span>
                    <span class="price-discount-percent">
                      {{
                        getPercentDiscount(
                          Number(item.desconto),
                          Number(item.preco)
                        )
                      }}% OFF
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Shop",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {};
  },
  beforeMount() {},
  watch: {
    products() {
      if (this.products && this.products.length == 1) {
        this.addItemToCart(this.products[0])
      }
    }
  },
  mounted() {
    // Solução para exibição do carousel corretamente
    let i = 0;
    let self = this;
    (function recall() {
      i++;
      if (i > 10) return null;
      setTimeout(() => {
        self.$refs.carousel
          ? self.$refs.carousel.computeCarouselWidth
          : recall();
      }, 500);
    })();
  },
  computed: {
    ...mapGetters(["products", "CONFIGS"]),
  },
  methods: {
    ...mapActions(["addItemToCart", "reduceQty", "addQty"]),
    perguntar() {
      // this.$swal.fire({
      //   icon: 'success',
      //   text: 'Sim?',
      //   showConfirmButton: true,
      // })
    },
    getPercentDiscount(totalValue, partialValue) {
      return (100 - (partialValue / totalValue) * 100).toFixed(0);
    },
    selectProduct(item, irParaElemento = null) {
      this.addItemToCart(item);
      this.$swal.fire({
        icon: "success",
        toast: true,
        position: "bottom-start",
        timer: 1400,
        timerProgressBar: true,
        showConfirmButton: false,
        title: "Adicionado ao carrinho",
      });

      const temporizador = setInterval(() => {
        const el = document.getElementsByClassName(irParaElemento)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          clearInterval(temporizador)
        }
      }, 100);
    },
  },
};
</script>

<style>
.VueCarousel-dot-container {
  margin-top: initial !important;
}
</style>